(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviv-team"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function initialize(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const listen = (target, name, fn) => target.addEventListener(name, fn, {signal: abort.signal});
    const cards = [...root.querySelectorAll('[data-person]')];
    const dialog = root.querySelector('#profile-dialog');
    const menu = root.querySelector('.menu-toggle');
    const mobileNav = root.querySelector('#mobile-nav');
    let current = 0, lastTrigger, savedOverflow = '';
    function showProfile(index) {
      if (!cards.length) return;
      current = (index + cards.length) % cards.length;
      const card = cards[current];
      root.querySelector('#profile-name').textContent = card.querySelector('[data-person-name]').textContent;
      root.querySelector('#profile-role').textContent = card.querySelector('[data-person-role]').textContent;
      root.querySelector('#dialog-portrait').replaceChildren(card.querySelector('.portrait').cloneNode(true));
      root.querySelector('#profile-bio').replaceChildren(card.querySelector('[data-person-bio]').content.cloneNode(true));
      root.querySelector('#profile-position').textContent = String(current + 1).padStart(2, '0') + ' / ' + cards.length;
      dialog.scrollTop = 0;
      if (!dialog.open) {
        savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      }
    }
    cards.forEach((card,index) => card.querySelectorAll('[data-open-profile]').forEach(button => {
      listen(button, 'click', () => {lastTrigger = button; showProfile(index);});
    }));
    listen(root.querySelector('.dialog-close'), 'click', () => dialog.close());
    listen(dialog, 'close', () => {document.body.style.overflow = savedOverflow; lastTrigger?.focus({preventScroll:true});});
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    listen(root.querySelector('#prev-profile'), 'click', () => showProfile(current - 1));
    listen(root.querySelector('#next-profile'), 'click', () => showProfile(current + 1));
    listen(dialog, 'keydown', event => {
      if (event.key === 'ArrowRight') {showProfile(current + 1); event.preventDefault();}
      if (event.key === 'ArrowLeft') {showProfile(current - 1); event.preventDefault();}
    });
    function closeMenu() {mobileNav.hidden = true; menu.setAttribute('aria-expanded','false');}
    listen(menu, 'click', () => {const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded',String(open)); mobileNav.hidden = !open;});
    mobileNav.querySelectorAll('a').forEach(link => listen(link, 'click', closeMenu));
    listen(root, 'keydown', event => {if(event.key === 'Escape' && !mobileNav.hidden) {closeMenu(); menu.focus();}});
    listen(document, 'shopify:block:select', event => {
      const index = cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
      if (index !== -1) {lastTrigger = cards[index].querySelector('[data-open-profile]'); showProfile(index);}
    });
    let observer;
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {entry.target.classList.add('revealed'); observer.unobserve(entry.target);}
      }), {threshold: .07});
      cards.forEach((card, index) => {if(index > 1) observer.observe(card);});
    }
    instances.set(root, () => {if(dialog.open){dialog.close();document.body.style.overflow=savedOverflow;}abort.abort();observer?.disconnect();instances.delete(root);});
  }
  function initializeAll() {document.querySelectorAll('[data-rxt-root]').forEach(initialize);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rxt-root]').forEach(root => instances.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
